import {
    SET_USER,
    GET_USER,
    SET_OPTIONS,
    SET_TAB_INDEX,
    SET_NEW_MESSAGE_DIALOG,
    SET_FILE_MANAGER_DIALOG,
    SET_LABELS, SET_MEMBER_DIALOG,
} from "redux/types";

export const setOptionsAction = ({title, primary, secondary, ...data}) => async dispatch => {
    try {
        dispatch({
            type: SET_OPTIONS,
            payload: {title, theme: {primary, secondary},...data}
        })
    } catch (e) {
        console.log('ERROR: ', e);
    }
}

export const setLabelAction = ({tabs, directory, status}) => async dispatch => {
    try {
        dispatch({
            type: SET_LABELS,
            payload: {tabs,directory}
        });
        if(status){
            localStorage.setItem('tabs', JSON.stringify(tabs))
            localStorage.setItem('directory', JSON.stringify(directory))
        }
    }catch (e) {
        console.log('ERROR: ', e);
    }
};

export const setFileManagerDialog = (status) => async dispatch => {
    try{
        dispatch({
            type: SET_FILE_MANAGER_DIALOG,
            payload: status
        })
    }catch (e) {
        console.log('ERRORS: ', e);
    }
};

export const setTabIndex = (index) => dispatch => dispatch({type: SET_TAB_INDEX, payload: index});

export const setNewMessageDialog = (status) => dispatch => dispatch({type: SET_NEW_MESSAGE_DIALOG, payload: status});

export const setMemberDialog = (status) => dispatch => dispatch({type: SET_MEMBER_DIALOG, payload: status});

export const setUser = (data) => dispatch => dispatch({type: SET_USER, payload: data})

export const getUser = (user) => dispatch => dispatch({type: GET_USER, payload: user});

export const setVariable = (type, payload) => dispatch => dispatch({type,payload});